module.exports = __webpack_public_path__ + "img/Data-Light.cb21c8b.svg";